/** Parse Elasticsearch ISO 8601 timestamps as UTC. */
export function parseEsTimestamp(iso: string): Date {
  const utc = iso.endsWith('Z') ? iso : `${iso}Z`;
  return new Date(utc);
}

const LOCAL_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
};

const SERVER_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZone: 'UTC',
  hour12: false,
};

/** Format a timestamp in the viewer's local timezone. */
export function formatLocalDateTime(date: Date): string {
  return date.toLocaleString(undefined, LOCAL_TIME_OPTIONS);
}

/** Format a timestamp in server/UTC time. */
export function formatServerDateTime(date: Date): string {
  return `${date.toLocaleString('en-US', SERVER_TIME_OPTIONS)} UTC`;
}

/** Tooltip text showing server time for a localized timestamp display. */
export function getServerTimeTooltip(date: Date): string {
  return `Server: ${formatServerDateTime(date)}`;
}
